"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
exports.default = react_jss_1.createUseStyles({
    spoiler: {
        position: 'relative',
    },
    content: function (_a) {
        var transitionDuration = _a.transitionDuration;
        return ({
            overflow: 'hidden',
            transitionProperty: 'max-height',
            transitionTimingFunction: 'ease',
            transitionDuration: transitionDuration || 0,
        });
    },
}, { link: true });
